import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import {
  ContainerDivs,
  // Link,
  LinkIcon
} from '../'
import Styles from './FootprintDeprecated.css'
// import config from '../../config'

@CSSModules(Styles)
export default class FootprintDeprecated extends Component {
  render() {
    return (
      <div styleName='footprint-deprecation-notice-wrap'>
        <div styleName='footprint-deprecation-notice-icon'>
          <LinkIcon nospace faclass='fa-exclamation-triangle'/>
        </div>
        <div styleName='footprint-deprecation-notice-text'>
          <h2>
            WARNING: Carbon footprint data is no longer being updated.
          </h2>
          <p>
            As of 2023, we are no longer updating fund carbon footprint
            data.
            This is due to a lack of access to regularly-updated
            company-level carbon footprint data.
            We are looking into whether we can find a new source for this
            data.
            Until then, all fund carbon footprint data should be considered
            out of date.
          </p>
        </div>
      </div>
    )
  }
}

